import { render, staticRenderFns } from "./ConnectedAccountCard.vue?vue&type=template&id=13121c7c&"
import script from "./ConnectedAccountCard.vue?vue&type=script&lang=js&"
export * from "./ConnectedAccountCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports